import { ComponentProps } from 'react';
import { bordColorTheme } from '../../../../styles/styles.constants';

const BordStockOrderIcon = (props: ComponentProps<'svg'>) => {
  const { stroke } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
      <path
        stroke={stroke || bordColorTheme.navyBlue[400]}
        strokeWidth="1.5"
        d="M2.90058 7.39887C2.81113 7.40029 2.7217 7.40176 2.63229 7.4033C2.09226 7.41255 1.57705 7.12422 1.3909 6.61721C1.18553 6.05781 1.07129 5.48258 1.07129 4.89032C1.07129 4.26738 1.18924 3.65467 1.41616 3.0691C1.59275 2.6134 2.04699 2.3439 2.53513 2.32031C4.90583 2.20578 7.41857 2.14307 9.99986 2.14307C12.5768 2.14307 15.041 2.20975 17.4391 2.32101C17.941 2.3443 18.4054 2.62734 18.5837 3.09711C18.8029 3.67481 18.9284 4.2768 18.9284 4.89032C18.9284 5.47608 18.8013 6.0459 18.6001 6.5995C18.4134 7.11322 17.9013 7.42018 17.3547 7.41871C17.0974 7.41802 16.8405 7.41714 16.5838 7.4161M2.90058 7.39887C2.73338 7.58189 2.61625 7.81162 2.5714 8.06897C2.31922 9.51621 2.18736 11.049 2.18736 12.6112C2.18736 14.1476 2.32403 15.6316 2.56449 17.0674C2.67019 17.6986 3.20399 18.1622 3.84159 18.2179C5.73022 18.3831 7.7069 18.6052 9.7423 18.6052C11.7963 18.6052 13.7758 18.4654 15.688 18.2532C16.3046 18.1849 16.8027 17.7184 16.9027 17.1061C17.139 15.6596 17.2973 14.161 17.2973 12.6112C17.2973 11.0558 17.1539 9.53447 16.9093 8.09078C16.8655 7.83247 16.7497 7.60123 16.5838 7.4161M2.90058 7.39887C7.38819 7.32774 11.9331 7.39735 16.5838 7.4161"
      />
      <path 
        stroke={stroke || bordColorTheme.navyBlue[400]}
        strokeWidth="1.5"
        strokeLinecap="round" 
        strokeLinejoin="round" 
        d="M7.68213 11.5864H11.803" 
      />
    </svg>
  );
};

export default BordStockOrderIcon;
